var $488280bd36ed5fc6$exports = {};
$488280bd36ed5fc6$exports = {
    "loading": `Nalaganje...`,
    "loadingMore": `Nalaganje ve\u{10D} vsebine...`
};


export {$488280bd36ed5fc6$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
